"use client";

import React from "react";
import { Phone, Mail, MapPin } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Kontaktbereich() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="kontaktbereich" ref={ref} className={`dark bg-background text-foreground py-20 lg:py-32 overflow-hidden transition-opacity duration-700 ${isVisible ? "opacity-100" : "opacity-0"}`}>
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-12 lg:gap-20 justify-items-center">
          <div className="space-y-12 text-center max-w-3xl w-full">
            <div className="space-y-6">
              <h2 className="text-4xl md:text-5xl font-bold tracking-tight text-foreground">
                Kontakt
              </h2>
              <p className="text-xl text-muted-foreground max-w-md leading-relaxed mx-auto">
                Für Ihr nächstes Smart-Home-, Energie- oder Automationsprojekt sind wir gerne für Sie da. Wir beraten Sie persönlich, praxisnah und unverbindlich.
              </p>
            </div>

            <div className="space-y-12">
              <div className="group">
                <div className="flex items-center justify-center gap-3 text-muted-foreground mb-2">
                  <Phone className="size-5" />
                  <span className="text-sm font-medium uppercase tracking-wider">
                    Telefon
                  </span>
                </div>
                <Link to="tel:+41774417863" className="text-2xl md:text-4xl font-bold text-primary hover:text-primary/80 transition-colors break-words">
                  +41 77 441 78 63
                </Link>
              </div>

              <div className="group">
                <div className="flex items-center justify-center gap-3 text-muted-foreground mb-2">
                  <Mail className="size-5" />
                  <span className="text-sm font-medium uppercase tracking-wider">
                    E-Mail
                  </span>
                </div>
                <Link to="mailto:info@s2automation.ch" className="text-2xl md:text-4xl font-bold text-primary hover:text-primary/80 transition-colors break-all">
                  info@s2automation.ch
                </Link>
              </div>

              <div className="group">
                <div className="flex items-center justify-center gap-3 text-muted-foreground mb-2">
                  <MapPin className="size-5" />
                  <span className="text-sm font-medium uppercase tracking-wider">
                    Standort
                  </span>
                </div>
                <p className="text-xl md:text-2xl font-medium text-foreground">
                  Oberwallis, Schweiz
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}